import React from "react";
import '../assets/css/Tour360.css'

const Tour360SkyCrest8 = () => {
    const preventIframeRedirect = (event) => {
        event.preventDefault();
        event.stopPropagation();
    };
    return (
        <div className="full-container">
            <iframe title="360 tour" src="https://surbhi-infotech-360.s3.ap-south-1.amazonaws.com/Sky_Crest_8_Walkthrough/index.htm" widh={"100%"} height={"100%"} className="tour-iframe" onDoubleClick={preventIframeRedirect} allow="xr-spatial-tracking fullscreen" />
        </div>
    )
}

export default Tour360SkyCrest8;